import React, { Component } from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'

class Toggle extends Component{
    constructor(props){
        super(props)
    }
    render(){
        if(this.props){
            let answer = this.props.answer;
            return(
                //<Radio>Answer</Radio>
                <FormControlLabel style={{paddingBottom:'8px'}} value={answer.AnswerId} control={<Radio />} label={answer.AnswerStandardContent} />
            )
        } else return <p>nope</p> 
        
    }
}

export default Toggle;